// Copyright © 2021 Move Closer
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export var AbstractNavItemTag;
(function (AbstractNavItemTag) {
    AbstractNavItemTag["Anchor"] = "a";
    AbstractNavItemTag["Button"] = "button";
})(AbstractNavItemTag || (AbstractNavItemTag = {}));
